import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VideoBackground from '@/components/VideoBackground';
import { useToast } from '@/hooks/use-toast';
import JoinTripModal from '@/components/JoinTripModal';
import { Globe, UserPlus, Briefcase } from 'lucide-react';
import { useAuth } from '@/contexts/auth';
import { MagnetizeButton } from '@/components/ui/magnetize-button';
const Index = () => {
  const {
    toast
  } = useToast();
  const navigate = useNavigate();
  const [joinTripModalOpen, setJoinTripModalOpen] = useState(false);
  const {
    user
  } = useAuth();
  const handleCreateTrip = () => {
    if (user) {
      // If user is already logged in, redirect to create trip page
      navigate('/dashboard');
    } else {
      // If not logged in, redirect to auth page
      navigate('/auth');
    }
  };
  const handleJoinTrip = () => {
    setJoinTripModalOpen(true);
  };
  const handleMyTrips = () => {
    navigate('/trips');
  };
  return <div className="relative min-h-screen w-full flex flex-col">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <VideoBackground />
      </div>

      {/* Content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-4">
        <div className="container mx-auto max-w-4xl flex flex-col text-center">
          {/* Main Text Section */}
          <div className="mb-6 md:mb-10">
            <h1 className="text-purple-tertiary text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4">Organize Your Next Adventure.</h1>
            
          </div>
          
          {/* Buttons Section */}
          <div className="w-full flex justify-center">
            <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8">
              <MagnetizeButton onClick={handleCreateTrip} className="min-w-[200px] h-14 shadow-lg" defaultText="Create Trip" attractText="Create Trip">
                <span className="flex items-center">
                  <Globe className="w-5 h-5 mr-2" /> 
                  Create Trip
                </span>
              </MagnetizeButton>
              
              <MagnetizeButton onClick={handleJoinTrip} className="min-w-[200px] h-14 shadow-lg" defaultText="Join Trip" attractText="Join Trip">
                <span className="flex items-center">
                  <UserPlus className="w-5 h-5 mr-2" /> 
                  Join Trip
                </span>
              </MagnetizeButton>
              
              {/* My Trips button - only shown when user is logged in */}
              {user && <MagnetizeButton onClick={handleMyTrips} className="min-w-[200px] h-14 shadow-lg" defaultText="My Trips" attractText="My Trips">
                  <span className="flex items-center">
                    <Briefcase className="w-5 h-5 mr-2" /> 
                    My Trips
                  </span>
                </MagnetizeButton>}
            </div>
          </div>
        </div>
      </div>

      {/* Join Trip Modal */}
      <JoinTripModal open={joinTripModalOpen} onOpenChange={setJoinTripModalOpen} />
    </div>;
};
export default Index;